import { DeleteData } from "./firebase/useFirebase";
import { Actions } from "../components/buttons/Actions";
import { useAppContext } from "../context/useAppContext";
import { ShopForm } from "../forms/ShopForm";
import { sUpdateShop } from "../constants/strings";
import { TelLink } from "../components/common/Common";
import { useReportStats } from "./common/useCommon";
import { dateTimeFormat } from "../utils/formatter";
import { actionsColumn, createdColumn } from "../constants/objects";

export const useShops = () => {
  const { contextData } = useAppContext();
  const { updateReportStats } = useReportStats();

  const shopsTableData = (data) => [
    ...data.map((item) => {
      const row = {
        timestamp: dateTimeFormat(item?.timestamp),
        shop_name: item.shop_name,
        phone: (
          // <DescWrapper>
          <TelLink phone={item.phone} />
          // </DescWrapper>
        ),
        location: item.location,
        // active: (
        //   <GenericSwitch end checked={item.active} docRef={item.docRef} />
        // ),
        onclick: () =>
          contextData.showGlobalDrawer({
            component: <ShopForm data={item} />,
            title: sUpdateShop,
          }),
        actions: (
          <Actions
            actions={[
              { action: "Edit" },
              {
                action: "Delete",
                click: () => {
                  DeleteData(item.docRef);
                  updateReportStats("shops", -1);
                },
                confirm: true,
              },
            ]}
          />
        ),
      };
      return row;
    }),
  ];

  const shopsTableColumns = () => [
    { id: "shop_name", title: "Shop Name", align: "left" },
    { id: "phone", title: "Phone" },
    { id: "location", title: "Location" },
    createdColumn,
    actionsColumn,
  ];

  return { shopsTableColumns, shopsTableData };
};
